export default {
  constant: 'constant',
  once: 'once',
  times: 'times'
};
